import { render, staticRenderFns } from "./Dysfunction.vue?vue&type=template&id=4653f932&scoped=true"
import script from "./Dysfunction.vue?vue&type=script&lang=js"
export * from "./Dysfunction.vue?vue&type=script&lang=js"
import style0 from "./Dysfunction.vue?vue&type=style&index=0&id=4653f932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4653f932",
  null
  
)

export default component.exports